export const WHITE_COLOR: string = '#ffffff'
export const BLACK_COLOR: string = '#000000'
export const ACCENT_COLOR: string = '#ffd24f'
